<style src="./NotificationCard.scss" lang="scss" scoped></style>
<template>
  <div class="notification-card">
    <span class="title">NOTIFICAÇÃO</span>
    <div class="notifycode">
      <span class="code">{{ info.creditCode }}</span>
      <i
        v-for="(photo, photoIdx) in info.photos"
        :key="photoIdx"
        @click="openImage(photo)"
        v-show="info.photos.length > 0"
        class="fa fa-camera modal-icon"
      >
      </i>
    </div>
  </div>
</template>

<script>
import { URI } from '../../../config/config';

export default {
  name: 'Notification',
  props: {
    info: {
      default: {},
    },
  },
  methods: {
    openImage(photo) {
      let photoPath = photo.replace(
        '/var/app/server-user-manager/notify-photos/',
        '',
      );
      photoPath = photoPath.replace(
        '/var/app/server-manager/notify-photos/',
        '',
      );

      window.open(`${URI}${photoPath}`);
    },
  },
};
</script>